import { Form } from "antd";
import { RdRawMaterialRequisitionFormValue } from "../../../type";
import { usePriceToPriceHkd } from "@/hooks/behaviors/usePriceToPriceHkd";
import { useEffect } from "react";
import Big from "big.js";
import { FormInstance } from "antd/lib";

export function useSupplierInfoFields(
  form: FormInstance<RdRawMaterialRequisitionFormValue>,
) {
  const { useWatch } = Form;

  const quantity = useWatch("quantity", form) ?? "";
  const price = useWatch("price", form) ?? "";
  const priceUnit = useWatch("priceUnit", form) ?? "";
  const totalAmount = useWatch("totalAmount", form) ?? "";

  // 计算单价金额 HKD
  const priceHkd = usePriceToPriceHkd(price, priceUnit);
  // 计算总金额 HKD
  const totalAmountHkd = usePriceToPriceHkd(totalAmount, priceUnit);

  useEffect(() => {
    if (priceHkd) {
      form.setFieldsValue({ priceHkd });
    }
  }, [priceHkd, form]);

  useEffect(() => {
    if (price && priceUnit) {
      form.setFieldsValue({
        totalAmount: new Big(price || 0).times(quantity || 0).toString(),
      });
    }
  }, [price, priceUnit, form, quantity]);

  useEffect(() => {
    if (totalAmountHkd) {
      form.setFieldsValue({ totalAmountHkd });
    }
  }, [totalAmountHkd, form]);

  return {
    priceHkd,
    totalAmountHkd,
  };
}
